"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsts = __importStar(require("jsts"));
var LinearRing_1 = __importDefault(require("./LinearRing"));
var Point_1 = __importDefault(require("./Point"));
var Polygon_1 = __importDefault(require("./Polygon"));
var MultiPoint_1 = __importDefault(require("./MultiPoint"));
var LineString_1 = __importDefault(require("./LineString"));
var WkbUtils_1 = __importDefault(require("../shared/WkbUtils"));
var MultiLineString_1 = __importDefault(require("./MultiLineString"));
var GeometryCollection_1 = __importDefault(require("./GeometryCollection"));
var GeometryFactory = /** @class */ (function () {
    function GeometryFactory() {
    }
    GeometryFactory.buildCircle = function (center, radius, segments) {
        if (segments === void 0) { segments = 36; }
        if (segments < 4) {
            throw new Error('segments must be greater than 3.');
        }
        var angle = 2 * Math.PI / segments;
        var coordinates = new Array();
        for (var i = 0; i < segments; i++) {
            var x = center.x + radius * Math.cos(angle * i);
            var y = center.y - radius * Math.sin(angle * i);
            coordinates.push({ x: x, y: y });
        }
        coordinates.push({ x: coordinates[0].x, y: coordinates[0].y });
        return new Polygon_1.default(new LinearRing_1.default(coordinates));
    };
    GeometryFactory.buildEllipse = function (center, radiusX, radiusY, segments) {
        if (segments === void 0) { segments = 36; }
        if (segments < 4) {
            throw new Error('segments must be greater than 3.');
        }
        var angle = 2 * Math.PI / segments;
        var coordinates = new Array();
        for (var i = 0; i < segments; i++) {
            var x = center.x + radiusX * Math.cos(angle * i);
            var y = center.y - radiusY * Math.sin(angle * i);
            coordinates.push({ x: x, y: y });
        }
        coordinates.push({ x: coordinates[0].x, y: coordinates[0].y });
        return new Polygon_1.default(new LinearRing_1.default(coordinates));
    };
    GeometryFactory.buildStar = function (center, vertexCount, radiusLong, radiusShort) {
        if (vertexCount < 3) {
            throw new Error('vertexCount must be larger than 2.');
        }
        radiusShort = radiusShort || radiusLong * .5;
        var step = Math.PI / vertexCount;
        var coordinates = new Array();
        for (var i = 0; i < vertexCount * 2; i++) {
            var radius = i % 2 === 0 ? radiusLong : radiusShort;
            var x = center.x + radius * Math.cos(step * i);
            var y = center.y - radius * Math.sin(step * i);
            coordinates.push({ x: x, y: y });
        }
        coordinates.push({ x: coordinates[0].x, y: coordinates[0].y });
        return new Polygon_1.default(new LinearRing_1.default(coordinates));
    };
    GeometryFactory.buildSquare = function (center, sideLength) {
        var sideLengthHalf = sideLength * 0.5;
        var coordinates = new Array();
        coordinates.push({ x: center.x + sideLengthHalf, y: center.y + sideLengthHalf });
        coordinates.push({ x: center.x + sideLengthHalf, y: center.y - sideLengthHalf });
        coordinates.push({ x: center.x - sideLengthHalf, y: center.y - sideLengthHalf });
        coordinates.push({ x: center.x - sideLengthHalf, y: center.y + sideLengthHalf });
        coordinates.push({ x: coordinates[0].x, y: coordinates[0].y });
        return new Polygon_1.default(new LinearRing_1.default(coordinates));
    };
    GeometryFactory.buildRectangle = function (center, width, height) {
        var widthHalf = width * 0.5;
        var heightHalf = height * 0.5;
        var coordinates = new Array();
        coordinates.push({ x: center.x + widthHalf, y: center.y + heightHalf });
        coordinates.push({ x: center.x + widthHalf, y: center.y - heightHalf });
        coordinates.push({ x: center.x - widthHalf, y: center.y - heightHalf });
        coordinates.push({ x: center.x - widthHalf, y: center.y + heightHalf });
        coordinates.push({ x: coordinates[0].x, y: coordinates[0].y });
        return new Polygon_1.default(new LinearRing_1.default(coordinates));
    };
    /**
     * @deprecated Use envelopeAsPolygon(envelope: IEnvelope) instead.
     */
    GeometryFactory.createPolygon = function (envelope) {
        return this.envelopeAsPolygon(envelope);
    };
    GeometryFactory.envelopeAsPolygon = function (envelope) {
        return new Polygon_1.default(this.createLinearRing(envelope));
    };
    /**
     * @deprecated Use envelopeAsLinearRing(envelope: IEnvelope) instead.
     */
    GeometryFactory.createLinearRing = function (envelope) {
        return this.envelopeAsLinearRing(envelope);
    };
    GeometryFactory.envelopeAsLinearRing = function (envelope) {
        return new LinearRing_1.default([
            [envelope.minx, envelope.maxy],
            [envelope.maxx, envelope.maxy],
            [envelope.maxx, envelope.miny],
            [envelope.minx, envelope.miny],
            [envelope.minx, envelope.maxy]
        ].map(function (v) { return ({ x: v[0], y: v[1] }); }));
    };
    GeometryFactory.create = function (param) {
        if (param instanceof jsts.geom.Geometry) {
            return GeometryFactory._createByGeom(param);
        }
        else if (param instanceof Buffer) {
            return WkbUtils_1.default.wkbToGeom(param);
        }
        else if (typeof param === 'string') {
            return GeometryFactory._createByWKT(param);
        }
        else {
            return GeometryFactory._createByGeoJSON(param);
        }
    };
    GeometryFactory._createByWKT = function (wkt) {
        var reader = new jsts.io.WKTReader();
        var geomTS = reader.read(wkt);
        var geom = GeometryFactory.create(geomTS);
        return geom;
    };
    GeometryFactory._createByGeom = function (geom) {
        if (geom instanceof jsts.geom.Point) {
            return Point_1.default._from(geom);
        }
        else if (geom instanceof jsts.geom.LineString) {
            return LineString_1.default._from(geom);
        }
        else if (geom instanceof jsts.geom.LinearRing) {
            return LinearRing_1.default._from(geom);
        }
        else if (geom instanceof jsts.geom.Polygon) {
            return Polygon_1.default._from(geom);
        }
        else if (geom instanceof jsts.geom.MultiLineString) {
            return MultiLineString_1.default._from(geom);
        }
        else if (geom instanceof jsts.geom.MultiPoint) {
            return MultiPoint_1.default._from(geom);
        }
        else if (geom instanceof jsts.geom.GeometryCollection) {
            return GeometryCollection_1.default._from(geom);
        }
        else {
            throw new Error(geom + " is not supported.");
        }
    };
    GeometryFactory._createByGeoJSON = function (json) {
        var reader = new jsts.io.GeoJSONReader();
        var geom = reader.read(json);
        return GeometryFactory._createByGeom(geom);
    };
    return GeometryFactory;
}());
exports.default = GeometryFactory;
